import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import { Row, Form, Input, Col, Select, Collapse } from "antd";
import jsPDF from 'jspdf';

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import ProductionApi from "../common/Apis/ProductionApi";
import EmptyBox from "../common/CommonUI/EmptyBox";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const AllergensSheet = () => {
    const { Content } = Layout;
    const { Panel } = Collapse;

    const [HotHold, setHotHold] = React.useState([]);

    const [PaginatePage, setPaginatePage] = useState(0);
    const [FilterEnable, setFilterEnable] = useState(true);
    const [PaginatetotalPages, settotalPages] = useState(null);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [totalElements, setTotalElements] = useState(0);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({
        paginate: PaginateLimit,
    });
    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({
            paginate: value,
        });


        if (FilterEnable) {
            ProductionApi.ListProductionPaged(0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });
        } else {

            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=PRODUCTION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                );
            QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        let pageNew = page - 1
        if (FilterEnable) {
            ProductionApi.ListProductionPaged(pageNew, PaginateLimit)
                .then((response) => {
                    setPaginatePage(pageNew)
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });


        } else {

            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=PRODUCTION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                );
            QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };


    const getReheatProcess = useCallback(() => {
        ProductionApi.ListProductionPaged(PaginatePage, PaginateLimit).then((response) => {
            settotalPages(response.totalPages);
            setHotHold(response.payloadDto);
            setTotalElements(response.totalElements);

        })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    useEffect(() => {
        getReheatProcess();
        PageLoading();
    }, [getReheatProcess, PageLoading]);


    const handleRemovefilterProduction = (FiltergetProductionIndex) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction.splice(FiltergetProductionIndex, 1);
        setFilterRecipe(newfilterProduction);
        if (FiltergetProductionIndex == 0) {
            getReheatProcess();
        }
    };
    const handleClear = () => {
        getReheatProcess();
        setFilterEnable(true);
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterRecipe([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };
    const formRef = useRef(null);

    const [filterRecipe, setFilterRecipe] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterRecipe = () => {
        setFilterRecipe([
            ...filterRecipe,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setFilterEnable(false);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        let singleLineString = filterRecipe
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=BETWEEN${createDateTimestamp(
                        obj.answerType
                    )}AND${createDateTimestamp(obj.name)}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
        "componentCode=PRODUCTION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
        );
        QuestionnairesApi.FilterQuestionsetNext(filderData,0,PaginateLimit)
            .then((response) => {
                setCurrentPage(1);
                settotalPages(response.totalPages);
                setHotHold(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => { });
    };
    const createDateTimestamp = (Cdate) => {
        const date = new Date(Cdate);
        const unixTime = Math.floor(date.getTime());
        return unixTime;
    };
    const handleChangeTitle = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].title = value;
        setFilterRecipe(newfilterProduction);
    };
    const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].answerType = value;
        setFilterRecipe(newfilterProduction);
    };

    const handleChangename = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].name = value;
        setFilterRecipe(newfilterProduction);
    };

    const paginatedData = HotHold;

    function convertToAMPM(timeString) {
        if (!timeString) return '';

        const [hours, minutes] = timeString.split(':');
        let formattedTime = '';

        let formattedHours = parseInt(hours, 10);
        const ampm = formattedHours >= 12 ? 'PM' : 'AM';
        formattedHours = formattedHours % 12 || 12;

        const formattedMinutes = minutes.padStart(2, '0');

        formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
        return formattedTime;
    }

    const handlePrintButtonClick = () => {
        const fontSize = 12;
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [210, 297], // A4 size
        });

        let yPos = 35;
        doc.setFontSize(fontSize);

        const currentDate = new Date().toLocaleDateString();
        const currentTime = new Date().toLocaleTimeString();
        const promises = [];

        for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
            if (FilterEnable) {
                promises.push(

                    ProductionApi.ListProductionPaged(i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Allergens Sheet`, 105, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 45, yPos);
                        doc.text('Product Description', 75, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('Allergen Info', 165, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 195, 10);
                        yPos += 10;

                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.productionCreateDate);
                            const time = convertToAMPM(row?.cookingTime);
                            const description = row?.recipeDTO?.recipeName;
                            const batchCode = row?.batchCode;
                            const allergenInfo = row?.allergensDTO?.map(item => item?.allergensName)?.join('/ ');

                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(time, 45, yPos);
                            doc.text(description, 75, yPos);
                            doc.text(batchCode, 125, yPos);
                            const allergenLines = doc.splitTextToSize(allergenInfo, 40);
                            doc.text(allergenLines, 165, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 195, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            } else {

                let singleLineString = filterRecipe
                    .map((obj) => {
                        if (obj.answerType === "%") {
                            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                        } else if (obj.answerType === "=") {
                            return `${obj.title}${obj.answerType}${obj.name}`;
                        } else {
                            return `${obj.title}=BETWEEN${createDateTimestamp(
                                obj.answerType
                            )}AND${createDateTimestamp(obj.name)}`;
                        }
                    })
                    .join("&");

                let filderData = window.btoa(
                    "componentCode=PRODUCTION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                    );

                promises.push(
                    QuestionnairesApi.FilterQuestionsetNext(filderData, i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Allergens Sheet`, 105, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 45, yPos);
                        doc.text('Product Description', 75, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('Allergen Info', 165, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 195, 10);
                        yPos += 10;

                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.productionCreateDate);
                            const time = convertToAMPM(row?.cookingTime);
                            const description = row?.recipeDTO?.recipeName;
                            const batchCode = row?.batchCode;
                            const allergenInfo = (row?.allergensDTO) ? row?.allergensDTO?.map(item => item?.allergensName)?.join('/ ') : row?.allergens;

                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(time, 45, yPos);
                            doc.text(description, 75, yPos);
                            doc.text(batchCode, 125, yPos);
                            const allergenLines = doc.splitTextToSize(allergenInfo, 40);
                            doc.text(allergenLines, 165, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 195, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            }

        }

        const reversedPromises = promises.map(promise =>
            promise.then(result =>
                new Promise(resolve =>
                    setTimeout(() => resolve(result), 0)
                )
            )
        );

        Promise.all(reversedPromises)
            .then(() => {
                window.open(doc.output('bloburl'), '_blank');
            })
            .catch((err) => {
                console.log(err);
            });

    };




    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">
                    <td style={{ width: "5%" }} className="pt-3 ">
                        {formatDate(item?.productionCreateDate)}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 ">
                        {convertToAMPM(item?.cookingTime)}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 ">
                        {item?.recipeDTO?.recipeName}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 ">
                        <div style={{
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            whiteSpace: 'nowrap',
                            maxWidth: '200px',
                            marginBottom: '10px',
                            marginTop: '-3px',
                            padding: '0px 0px 20px',
                            display: 'block',
                            }}>
                            {item?.batchCode}
                        </div>  
                    </td>
                    <td style={{ width: "10%" }} className="pt-3 ">
                        {(item?.allergensDTO) ? item?.allergensDTO?.map(item => item?.allergensName)?.join(' / ') : item?.allergens}
                    </td>

                </tr>
            ));
        } else {
            return (<>
                <tr className="text-center EmptyTable">
                    <td colSpan={5} className="text-center ">
                        <EmptyBox />

                    </td>
                </tr></>
            );
        }
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader onPrintResponse={handlePrintButtonClick} />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterRecipe.map((input, filterProductionIndex) => (
                                        <div key={filterProductionIndex}>
                                            <Row gutter={24} className="pt-2">
                                                <Col lg={5} md={5} className="px-1">
                                                    <Form.Item
                                                        name={`title${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterProductionIndex, value)
                                                            }
                                                            options={[

                                                                {
                                                                    value: "recipe.recipeName",
                                                                    label: "Product Description",
                                                                },
                                                                {
                                                                    value: "batchCode",
                                                                    label: "Batch Code",
                                                                },
                                                                {
                                                                    value: "productionCreateDate",
                                                                    label: "Date",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col lg={4} md={4} className="px-1">
                                                    {filterRecipe[filterProductionIndex].title ==
                                                        "productionCreateDate" ? (
                                                        <>
                                                            <Form.Item
                                                                name={`nameto${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select Start Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    placeholder="Filter By"
                                                                    onChange={(e) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name={`type${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select type.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    placeholder="Condition"
                                                                    onChange={(value) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            value
                                                                        )
                                                                    }
                                                                    options={[
                                                                        { value: "%", label: "Matches with" },
                                                                        {
                                                                            value: "=",
                                                                            label: "Equals to",
                                                                        },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>


                                                <Col lg={5} md={5} className="px-1">
                                                    {filterRecipe[filterProductionIndex].title ==
                                                        "productionCreateDate" ? (
                                                        <>
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select End Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter Text.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>


                                                <Col lg={8} md={10} className="px-1">
                                                    <Form.Item className="text-lable">
                                                        {filterProductionIndex == 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterRecipe}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center "
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {" "}
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterProduction(
                                                                            filterProductionIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>

                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <></>
                            </div>
                            <div>

                                <Form
                                    form={formPaginate}
                                >
                                    <Form.Item
                                        name="paginate"
                                        className="text-lable"
                                        style={{ width: '100px' }}
                                    >
                                        <Select
                                            className="control-Select"
                                            onChange={(value) => {
                                                handlesetPaginateLimit(value)
                                            }}
                                            options={[
                                                { value: 10, label: "10" },
                                                { value: 20, label: "20" },
                                                { value: 30, label: "30" },
                                                { value: 40, label: "40" },
                                                { value: 50, label: "50" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Form>

                            </div>
                        </div>
                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Product Description</th>
                                    <th>Batch Code</th>
                                    <th>Allergen Info</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                        {paginatedData.length > 0 && (
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={PaginatetotalPages}
                                        onPageChange={handlePageChange}
                                        maxVisiblePages={5}
                                        showPageInfo={true}
                                        totalItems={totalElements}
                                        pageSize={PaginateLimit}
                                    />
                    )}
                    </div>
                </Content>


                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default AllergensSheet;
